// import _get from 'lodash.get';
import _get from 'lodash.get';
import produce from 'immer';
import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from 'reduxUtils/reducerRegistry';
import { TOI_HOMEPAGE_CARDCMS_LITE_URL } from 'constants/index.js';
import makeRequest from 'utils/makeRequest';
import { getSiteDomain } from 'utils/common';
import { receiveAdsData } from 'helpers/ads/revenueRedux';

//import makeRequest from '../../utils/makeRequest';
//import * as cookie from '../../utils/cookies';

const reducerName = 'homepage';
const createActionName = name => `toi/${reducerName}/${name}`;

/* const DESKTOP_HP_API =
  'http://localhost:3000/dummyfeeds/us_hp_desktop_test.json';
const MOBILE_HP_API = 'http://localhost:3000/dummyfeeds/us_hp_mobile_test.json'; */

// const AJAX_SECTION_API = '/dummyfeeds/us_hp_mobile_ajax_test.json';
const HP_CONTENT_FEED_PATH = '/toi/web/page/content?path=/';
const WAP_HP_CONTENT_FEED_PATH =
  '/mobilehomepagefeedspadata.cms?feedtype=sjson';
const WAP_HP_CONTENT_FEED_PATH_TEST =
  '/mobilehomepagefeedspadata_rndfeed.cms?feedtype=sjson';
const WEB_HP_CONTENT_FEED_PATH_TEST =
  '/webhomepagefeedspadatatest.cms?feedtype=sjson';
const WEB_HP_CONTENT_FEED_PATH = '/webhomepagefeedspadata.cms?feedtype=sjson';
const WEB_HP_GCC_CONTENT_FEED_PATH =
  '/gccwebhomepagefeedspadata.cms?feedtype=sjson';
const WAP_HP_GCC_CONTENT_FEED_PATH =
  '/gccmobilehomepagefeedspadata.cms?feedtype=sjson';
const ELECTION_CONTENT_FEED_PATH =
  '/homepage_election_feed.cms?msid=102278998&feedtype=sjson';
const MCD_ELECTION_CONTENT_FEED_PATH =
  '/homepage_mcd_election_feed.cms?feedtype=sjson';
const SHORT_VIDEO_FEED_PATH = '/feed_short_playlist_details.cms?feedtype=sjson';
// const ELECTION_CONTENT_FEED_PATH = '/homepage_exitpll_feed.cms?feedtype=sjson';

export const RECEIVE_HOME_PAGE_DATA = createActionName(
  'RECEIVE_HOME_PAGE_DATA',
);
export const RECEIVE_PAGINATION_DATA = createActionName(
  'RECEIVE_PAGINATION_DATA',
);
export const RECEIVE_AJAX_SECTION_DATA = createActionName(
  'RECEIVE_AJAX_SECTION_DATA',
);
export const HANDLE_HOME_PAGE_DATA_ERROR = createActionName(
  'HANDLE_DATA_ERROR',
);
export const ADD_NEXT_VIDEO_MSID = createActionName('ADD_NEXT_VIDEO_MSID');

export const SHOW_VIDEO_SECTION_LOADER = createActionName(
  'SHOW_VIDEO_SECTION_LOADER',
);

export const SHOW_TECH_SECTION_LOADER = createActionName(
  'SHOW_TECH_SECTION_LOADER',
);

export const DATA_LOADING = createActionName('DATA_LOADING');

export const DATA_LOADED = createActionName('DATA_LOADED');

export const RECEIVE_ELECTION_DATA = createActionName('RECEIVE_ELECTION_DATA');
export const RECEIVE_MCD_ELECTION_DATA = createActionName(
  'RECEIVE_MCD_ELECTION_DATA',
);

export const HANDLE_ELECTION_DATA_ERROR = createActionName(
  'HANDLE_ELECTION_DATA_ERROR',
);
export const HANDLE_MCD_ELECTION_DATA_ERROR = createActionName(
  'HANDLE_MCD_ELECTION_DATA_ERROR',
);
// Card-Inserts Actions
export const RECEIVE_CARDS_INSERT_LITE_DATA = createActionName(
  'RECEIVE_CARDS_INSERT_LITE_DATA',
);
export const HANDLE_CARDS_INSERTS_DATA_LITE_ERROR = createActionName(
  'HANDLE_CARDS_INSERTS_DATA_LITE_ERROR',
);

export const RECEIVE_SHORT_VIDEOS_DATA = createActionName(
  'RECEIVE_SHORT_VIDEOS_DATA',
);
export const HANDLE_VIDEOS_DATA_ERROR = createActionName(
  'HANDLE_VIDEOS_DATA_ERROR',
);

function fetchUSHomePageData(params) {
  /* const url = params.isWapView
    ? MOBILE_HP_API
    : DESKTOP_HP_API; */
  const requestParams = {
    params: {},
    isMobile: params.isWapView,
  };
  //@todo can't we use object.assign here or use the params directly ?
  //@todo any other use-ase we are catering to ?
  if (params.curpg) {
    requestParams.params.curpg = params.curpg;
  }
  //@todo there could be array of permissible params and those can be read in loop to form the URL parameters ?
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const url = `${getFeedUrl()}${HP_CONTENT_FEED_PATH}${primeParam}`;
  //console.log(`${getFeedUrl()}${HP_CONTENT_FEED_PATH}`)
  return makeRequest.get(url, requestParams);
}

function fetchHomePageData(params) {
  const requestParams = {
    params: {},
  };
  let feedPath = '';

  if (params.testExpando && !params.isWapView) {
    feedPath = WEB_HP_CONTENT_FEED_PATH_TEST;
  } else if (params.rndfeed && params.rndfeed === '1') {
    feedPath = WAP_HP_CONTENT_FEED_PATH_TEST;
  } else if (params.path === '/gcc') {
    feedPath = params.isWapView
      ? WAP_HP_GCC_CONTENT_FEED_PATH
      : WEB_HP_GCC_CONTENT_FEED_PATH;
  } else if (params.isWapView) {
    feedPath = WAP_HP_CONTENT_FEED_PATH;
  } else {
    feedPath = WEB_HP_CONTENT_FEED_PATH;
  }

  // @todo there could be array of permissible params and those can be read in loop to form the URL parameters ?
  const primeParam = params.isPrime ? '&pc1=yes' : '';
  const geoclParam = params.geocl ? `&geocl=${params.geocl}` : '';
  const geolocationParam = params.geolocation
    ? `&geolocation=${params.geolocation}`
    : '';
  const testExpando = params.testExpando ? '&test=expando' : '';
  const url = `${getSiteDomain()}${feedPath}${primeParam}${geoclParam}${geolocationParam}${testExpando}`;
  // console.log('fetchHomePageData url', url);
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

async function fetchElectionData(params) {
  const requestParams = {
    params: {},
  };
  const feedPath = ELECTION_CONTENT_FEED_PATH;
  const pfm = params.isWapView ? 'wap' : 'web';
  const url = `${getSiteDomain()}${feedPath}&pfm=${pfm}`;
  const response = await makeRequest.get(url, requestParams, 'skipfeedengine');
  if (
    response?.data?.result?.scores?.url &&
    response?.data?.result?.starcandidate?.url
  ) {
    const scores = await makeRequest.get(
      response.data.result.scores.url,
      requestParams,
      'skipfeedengine',
    );
    const starCandidate = await makeRequest.get(
      response.data.result.starcandidate.url,
      requestParams,
      'skipfeedengine',
    );
    response.data.result.starcandidate.data = starCandidate.data;
    response.data.result.scores.data = scores.data;
  } else if (response?.data?.exitpoll?.url) {
    const exitpoll = await makeRequest.get(
      response.data.exitpoll.url,
      requestParams,
      'skipfeedengine',
    );
    response.data.exitpoll.data = exitpoll.data;
  }
  return response;
}

function fetchMCDElectionData(params) {
  const requestParams = {
    params: {},
  };
  const feedPath = MCD_ELECTION_CONTENT_FEED_PATH;
  const pfm = params.isWapView ? 'wap' : 'web';
  const url = `${getSiteDomain()}${feedPath}&pfm=${pfm}`;
  // console.log('fetchHomePageData url', url);
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

function fetchCardsInsertLite() {
  return makeRequest.get(TOI_HOMEPAGE_CARDCMS_LITE_URL, 'skipfeedengine');
}

function fetchSectionAjaxData({ clickedItem, sectionId, isPrime }, isMobile) {
  const { subsectiondID, dataUrl } = clickedItem;
  const primeParam = isPrime ? '&pc=yes' : '';
  const url =
    dataUrl ||
    `${getFeedUrl()}${HP_CONTENT_FEED_PATH}&sectionid=${sectionId}&subsectionid=${subsectiondID}${primeParam}`;
  return makeRequest.get(url, { isMobile });
}

function fetchShortVideoData() {
  const requestParams = {
    params: {},
  };
  const feedPath = SHORT_VIDEO_FEED_PATH;
  //const pfm = params.isWapView ? 'wap' : 'web';
  const url = `${getSiteDomain()}${feedPath}`;
  return makeRequest.get(url, requestParams, 'skipfeedengine');
}

export function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

export function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

export function addNextVideoMsid(msidForNextVideo, slikeId) {
  return {
    type: ADD_NEXT_VIDEO_MSID,
    payload: { msidForNextVideo, slikeId },
  };
}

function handleHomePageDataError() {
  return {
    type: HANDLE_HOME_PAGE_DATA_ERROR,
    payload: {},
  };
}

export function reciveHomePageData(data) {
  return {
    type: RECEIVE_HOME_PAGE_DATA,
    payload: data,
  };
}

function receiveElectionData(data) {
  return {
    type: RECEIVE_ELECTION_DATA,
    payload: data,
  };
}

function receiveMCDElectionData(data) {
  return {
    type: RECEIVE_MCD_ELECTION_DATA,
    payload: data,
  };
}

function receiveCardInsertLiteData(data) {
  return {
    type: RECEIVE_CARDS_INSERT_LITE_DATA,
    payload: data,
  };
}

function receiveShortVideoDataData(data) {
  return {
    type: RECEIVE_SHORT_VIDEOS_DATA,
    payload: data,
  };
}

function handleElectionDataError() {
  return {
    type: HANDLE_ELECTION_DATA_ERROR,
    payload: {},
  };
}

function handleMCDElectionDataError() {
  return {
    type: HANDLE_MCD_ELECTION_DATA_ERROR,
    payload: {},
  };
}

function handleCardInsertLiteDataError() {
  return {
    type: HANDLE_CARDS_INSERTS_DATA_LITE_ERROR,
    payload: {},
  };
}

function handleShortVideoDataError() {
  return {
    type: HANDLE_VIDEOS_DATA_ERROR,
    payload: {},
  };
}

function receivePaginationData(data) {
  return {
    type: RECEIVE_PAGINATION_DATA,
    payload: data,
  };
}

function receiveSectionAjaxData(data, params) {
  return {
    type: RECEIVE_AJAX_SECTION_DATA,
    payload: {
      ajaxData: data,
      params,
    },
  };
}

function toggleVideosSectionLoader(showLoader) {
  return {
    type: SHOW_VIDEO_SECTION_LOADER,
    payload: {
      showLoader,
    },
  };
}

function toggleTechSectionLoader(showLoader) {
  return {
    type: SHOW_TECH_SECTION_LOADER,
    payload: {
      showLoader,
    },
  };
}

// export function loadIndiaHPData(data) {
//   return dispatch => {
//     dispatch(reciveHomePageData(data));
//   };
// }

export function loadElectionData(params) {
  return dispatch =>
    // dispatch(dataLoading());
    fetchElectionData(params)
      .then(response => {
        // dispatch(dataLoaded());
        dispatch(receiveElectionData(response.data, params));
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleElectionDataError(error));
      });
}

export function loadMCDElectionData(params) {
  return dispatch =>
    // dispatch(dataLoading());
    fetchMCDElectionData(params)
      .then(response => {
        // dispatch(dataLoaded());
        dispatch(receiveMCDElectionData(response.data, params));
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleMCDElectionDataError(error));
      });
}

const assignAdNamesRecursively = (sections, counters, keyMapper) => {
  if (!Array.isArray(sections) || !sections.length) return;
  sections.forEach(section => {
    if (!section) return;
    if (
      section.tn === 'ad' &&
      section.groupName &&
      !section.jname &&
      keyMapper[section.groupName]
    ) {
      const key = keyMapper[section.groupName];
      counters[key] = counters[key] || 0;
      const postfix = counters[key] || '';
      section.jname = `${key}${postfix}`;
      counters[key] += 1;
    }

    // Possible nested arrays to traverse
    const nestedLists = [
      section.items,
      section.inserts,
      section.ad_insert,
      section.below_inserts,
    ];

    nestedLists.forEach(list => {
      assignAdNamesRecursively(list, counters, keyMapper);
    });
  });
};

const updateAllAdNames = data => {
  try {
    const { sections, sectionitems } = data || {};
    const list = sections || sectionitems;
    const keyMapper = {
      midAds: 'mid',
      mrecs: 'mrec',
    };
    const counters = {};
    assignAdNamesRecursively(list, counters, keyMapper);
  } catch (e) {
    //
  }
};

export function loadIndiaHPData(params, staticFeed) {
  if (staticFeed) {
    return dispatch => {
      dispatch(reciveHomePageData(params));
    };
  }
  return dispatch =>
    // dispatch(dataLoading());
    fetchHomePageData(params)
      .then(response => {
        // dispatch(dataLoaded());
        if (!params.isPrime) {
          if (response?.data?.revenue) {
            dispatch(receiveAdsData(response.data.revenue));
            response.data.revenue = null;
            updateAllAdNames(response.data, params.isMobile);
          }
        }
        dispatch(reciveHomePageData(response.data, params));
      })
      .catch(error => {
        //dispatch(dataLoaded());
        dispatch(handleHomePageDataError(error));
      });
}

export function loadHomePageData(params) {
  return dispatch => {
    dispatch(dataLoading());
    return fetchUSHomePageData(params)
      .then(response => {
        dispatch(dataLoaded());
        if (params.curpg) {
          dispatch(receivePaginationData(response.data, params));
        } else {
          dispatch(reciveHomePageData(response.data, params));
        }
      })
      .catch(error => {
        dispatch(dataLoaded());
        dispatch(handleHomePageDataError(error));
      });
  };
}

export function loadAjaxSectionData(params) {
  let sectionId = '';
  if (typeof params.sectionId === 'string') {
    sectionId = params.sectionId.toLowerCase();
  }
  return (dispatch, getState) => {
    const appState = getState();
    const { isMobile } = appState;
    if (sectionId === 'videos') {
      dispatch(toggleVideosSectionLoader(true));
    } else if (sectionId === 'tech') {
      dispatch(toggleTechSectionLoader(true));
    }
    return fetchSectionAjaxData(params, isMobile)
      .then(response => {
        dispatch(receiveSectionAjaxData(response.data, params));
        if (sectionId === 'videos') {
          dispatch(toggleVideosSectionLoader(false));
        } else if (sectionId === 'tech') {
          dispatch(toggleTechSectionLoader(false));
        }
      })
      .catch(error => {
        dispatch(handleHomePageDataError(error));
        if (sectionId === 'videos') {
          dispatch(toggleVideosSectionLoader(false));
        } else if (sectionId === 'tech') {
          dispatch(toggleTechSectionLoader(false));
        }
      });
  };
}

export function loadCardInsertLiteData() {
  return dispatch =>
    fetchCardsInsertLite()
      .then(response => {
        dispatch(receiveCardInsertLiteData(response.data));
      })
      .catch(error => {
        dispatch(handleCardInsertLiteDataError(error));
      });
}

export function loadShortVideoData() {
  return dispatch =>
    fetchShortVideoData()
      .then(response => {
        dispatch(receiveShortVideoDataData(response?.data?.json?.items));
      })
      .catch(error => {
        dispatch(handleShortVideoDataError(error));
      });
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    case RECEIVE_HOME_PAGE_DATA: {
      return {
        ...state,
        data: action.payload,
      };
    }
    case RECEIVE_ELECTION_DATA: {
      return {
        ...state,
        electionData: action.payload,
      };
    }

    case RECEIVE_MCD_ELECTION_DATA: {
      return {
        ...state,
        electionMCDData: action.payload,
      };
    }

    case HANDLE_ELECTION_DATA_ERROR: {
      return {
        ...state,
        electionData: {},
      };
    }

    case HANDLE_MCD_ELECTION_DATA_ERROR: {
      return {
        ...state,
        electionMCDData: {},
      };
    }

    case RECEIVE_CARDS_INSERT_LITE_DATA: {
      return {
        ...state,
        cardsInsertsLite: action.payload,
      };
    }

    case HANDLE_CARDS_INSERTS_DATA_LITE_ERROR: {
      return {
        ...state,
        cardsInsertsLite: {},
      };
    }

    case RECEIVE_PAGINATION_DATA: {
      const { data = {}, pagination } = action.payload;
      const newState = produce(state, draftState => {
        const pageData = _get(draftState, 'data');
        pageData.data = [...pageData.data, ...data];
        pageData.pagination.currenPage = pagination.currenPage;
      });
      return newState;
    }
    case RECEIVE_AJAX_SECTION_DATA: {
      const { ajaxData = {} } = action.payload;
      const { params = {} } = action.payload;
      let indexOfFetchedSectionInSectionArray;
      const nextState = produce(state, draftState => {
        const pageData = _get(draftState, 'data');

        if (_get(pageData, 'sections') instanceof Array) {
          pageData.sections.forEach((item, index) => {
            if (params.sectionId === item.id) {
              indexOfFetchedSectionInSectionArray = index;
            }
          });

          if (typeof indexOfFetchedSectionInSectionArray === 'number') {
            pageData.sections[indexOfFetchedSectionInSectionArray].items =
              ajaxData.items;
          }
        } else {
          // console.log('section not found');
        }
      });

      return nextState;
    }
    case ADD_NEXT_VIDEO_MSID: {
      return {
        ...state,
        msidForNextVideo: action.payload.msidForNextVideo,
        slikeId: action.payload.slikeId,
      };
    }
    case HANDLE_HOME_PAGE_DATA_ERROR: {
      return {
        ...state,
      };
    }

    case SHOW_VIDEO_SECTION_LOADER: {
      return {
        ...state,
        showVideoSectionLoader: action.payload.showLoader,
      };
    }

    case SHOW_TECH_SECTION_LOADER: {
      return {
        ...state,
        showTechSectionLoader: action.payload.showLoader,
      };
    }

    case RECEIVE_SHORT_VIDEOS_DATA: {
      return {
        ...state,
        shortVideoData: action.payload,
      };
    }

    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
